import { renderComponent } from 'utils/RenderingUtils';
import { ICreateElementProps } from './CreateElement';

export async function renderCreateElement(container: HTMLElement, props: ICreateElementProps, callback?: () => void) {
  const { CreateElement } = await import('components/CreateElement/CreateElement');

  return renderComponent({
    container,
    component: <CreateElement {...props} />,
    callback,
    autoUnmount: true,
  });
}
